import React, { useEffect, useState, useCallback } from 'react'
import * as components from '../../components'
import { useDispatch } from 'react-redux'
import * as rest from '../../services'
import { showErrorToast } from '../../state/toasts'
import { ScheduledReportsDataGrid } from './ScheduledReportsDataGrid'
export const ScheduleReportPage = (props) => {
  const dispatch = useDispatch()
  const [getAPIResults, setGetAPIResult] = useState(null)
  const [loading, setLoading] = useState(false)
  const [gridData, setGridData] = useState({})
  const [hiddenRowKeys, setHiddenRowKeys] = useState([])
  const handleTableChange = (type, { page, sizePerPage }) => {
    const paginationFilters = {
      ...gridData,
      page: page,
      page_size: sizePerPage,
    }
    setGridData(paginationFilters)
  }
  const onFilter = (data) => {
    const searchFilters = data ? { ...data, page: 1 } : gridData
    setGridData({ ...searchFilters })
  }

  const getData = useCallback(
    (data) => {
      let finalPayload = { ...gridData, ...data }
      setGetAPIResult(null)
      setLoading(true)
      new rest.ReportsService()
        .makeGetRequest(finalPayload)
        .then((response) => {
          setGetAPIResult(response)
          setLoading(false)
        })
        .catch((errors) => {
          setLoading(false)
          dispatch(
            showErrorToast(
              'Could Not Load reports Data.',
              JSON.stringify(errors)
            )
          )
        })
    },
    [dispatch, gridData]
  )
  useEffect(() => {
    getData()
  }, [getData])

  return loading ? (
    <components.Loading />
  ) : (
    <>
      {getAPIResults && (
        <ScheduledReportsDataGrid
          onTableChange={handleTableChange}
          onFilter={onFilter}
          getData={getData}
          hiddenRowKeys={hiddenRowKeys}
          results={getAPIResults.results}
          pageSize={getAPIResults.page_size}
          count={getAPIResults.count}
          current={getAPIResults.current}
          onDelete={(item) => {
            setHiddenRowKeys([...hiddenRowKeys, item.url])
          }}
        />
      )}
    </>
  )
}
